import React, { useEffect } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Modal from '@8x8/oxygen-modal';
import ModalHeader from '@8x8/oxygen-modal-header';

import SocialButton from './social-button';
import {
  getSocialProvidersConfigList,
  SHOW_FIRST_N_SOCIAL_PROVIDERS_ON_MAIN_PAGE,
} from '../core/social-providers';
import TermsAndConditions from './basic/terms-and-conditions';
import { translate } from '~/services/translate';
import { isMobile } from '../core/utils';
import analytics from '../services/amplitude';
import { ColumnFlex } from '~/components/basic/containers';
import mainTheme from '~/core/theme';

const StyledModal = styled(Modal)`
  ${isMobile() ? `${mainTheme.sansSerif}` : `${mainTheme.nunitoFont}`};
  [data-id="OVERLAY_CONTAINER"] {
    background-color: #000;
    opacity: 0.6;
  }
`;

const Container = styled.div`
  padding: 32px 36px 0;
`;

const CustomHeader = styled.div`
  display: flex;
  align-self:center;
  word-wrap: newline;
  font-weight: 600;
  font-size: 24px;
  color: ${({ theme }) => theme.grayFont};
  text-align: center;
  max-width: 200px;
`;

const LegalContainer = styled(ColumnFlex)`
  margin-top: 16px;
`;

const MoreProviders = ({ isSignUp, onHide }) => {
  useEffect(() => {
    analytics.trackPageView(analytics.PAGE_NAMES.MORE_PROVIDERS);
  }, []);

  const socialProvidersConfigList = getSocialProvidersConfigList();
  const providersLength = socialProvidersConfigList.length;

  return (
    <StyledModal
      width="375px"
      visible
      alignTitle="center"
      theme={{ minHeight: '375px' }}
    >
      <ModalHeader onClose={onHide} />
      <CustomHeader>{isSignUp ? translate('sign_up_meet_pro') : translate('login')}</CustomHeader>
      <Container>
        {socialProvidersConfigList.slice(SHOW_FIRST_N_SOCIAL_PROVIDERS_ON_MAIN_PAGE, providersLength).map(provider => (
          <SocialButton
            data-test-id={`button-${provider.name} `}
            key={provider.name}
            backgroundColor={provider.backgroundColor}
            backgroundColorHover={provider.backgroundColorHover}
            Icon={provider.Icon}
            iconColor={provider.iconColor}
            text={provider.text}
            connectionName={provider.connectionName}
          />
        ))}
        <LegalContainer>
          {isSignUp && <TermsAndConditions />}
        </LegalContainer>
      </Container>
    </StyledModal>
  );
}

MoreProviders.propTypes = {
  isSignUp: PropTypes.bool,
  onHide: PropTypes.func,
};

export default MoreProviders;